/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Markdown_Show_MoreInputs */

const en_booking_markdown_show_more = /** @type {(inputs: Booking_Markdown_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show more`)
};

const pl_booking_markdown_show_more = /** @type {(inputs: Booking_Markdown_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż więcej`)
};

/**
* | output |
* | --- |
* | "Show more" |
*
* @param {Booking_Markdown_Show_MoreInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_markdown_show_more = /** @type {((inputs?: Booking_Markdown_Show_MoreInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Markdown_Show_MoreInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_markdown_show_more(inputs)
	return en_booking_markdown_show_more(inputs)
});